import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, Typography } from "@mui/material";

const SubmissionPopup = ({ open, countdown, stats }) => {
  return (
    <Dialog open={open}>
      <DialogTitle>Your exam has been submitted by the head authority!</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant="body1">Total Questions: {stats.totalQuestions}</Typography>
          <Typography variant="body1">Total Answered: {stats.attemptedWithAnswered}</Typography>
          <Typography variant="body1">Marked with answered: {stats.markedWithAnswered}</Typography>
          <Typography variant="body1">Marked without answered: {stats.markedWithotAnswered}</Typography>
          <Typography variant="body1">Not Answered: {stats.attemptedWithoutAnswered}</Typography>
          <Typography variant="body1">Not Viewed: {stats.notViewedQ}</Typography>
          Navigating to the end page in {countdown} seconds...
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default SubmissionPopup;